import React, { useState, useEffect } from "react";
import { COLORS } from "../../globalvariables";

function MissionSection({
  title,
  missionParts,
  previousButtonText = "Previous",
  nextButtonText = "Next",
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const safeMissionParts = Array.isArray(missionParts) ? missionParts : [];

  const nextSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % (safeMissionParts.length || 1)
    );
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + (safeMissionParts.length || 1)) %
        (safeMissionParts.length || 1)
    );
  };

  useEffect(() => {
    if (safeMissionParts.length > 0) {
      const startTimer = setTimeout(() => {
        const interval = setInterval(() => {
          nextSlide();
        }, 7000);
        return () => clearInterval(interval);
      }, 4000);
      return () => clearTimeout(startTimer);
    }
  }, [safeMissionParts]);

  if (safeMissionParts.length === 0) {
    return <div>Loading mission...</div>;
  }

  return (
    <section
      className="text-center px-4 py-8 md:py-16"
      id="mission"
      style={{ color: COLORS.textPrimary }}
    >
      <h3
        className="text-2xl md:text-4xl font-bold mb-8 md:mb-20"
        style={{ 
          color: COLORS.textPrimary,
          backgroundImage: `linear-gradient(to right, ${COLORS.textPrimary}, ${COLORS.primary} 50%, ${COLORS.textPrimary})`,
          WebkitBackgroundClip: "text", 
          WebkitTextFillColor: "transparent",
          position: "relative",
          fontSize: window.innerWidth <= 768 ? "1.8rem" : "2.5rem"
        }}
      >
        {title}
        <div
          style={{
            height: "3px",
            width: "60px",
            background: COLORS.primary,
            borderRadius: "3px",
            margin: "8px auto 0"
          }}
        />
      </h3>

      <div
        className="relative flex justify-center items-center"
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: window.innerWidth <= 768 ? "0 60px" : "0 100px", // espace pour les boutons
        }}
      >
        {/* Previous Button */}
        <button
          onClick={prevSlide}
          className={`absolute ${window.innerWidth <= 768 ? 'w-10 h-10 text-lg' : 'w-12 h-12 text-xl'} rounded-full transition-all duration-300 flex items-center justify-center`}
          style={{
            backgroundColor: COLORS.primary,
            color: COLORS.background,
            left: window.innerWidth <= 768 ? "5px" : "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            border: "none",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = "translateY(-50%) scale(1.1)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.transform = "translateY(-50%) scale(1)")
          }
          onMouseDown={(e) =>
            (e.currentTarget.style.backgroundColor = COLORS.primaryHover)
          }
          onMouseUp={(e) =>
            (e.currentTarget.style.backgroundColor = COLORS.primary)
          }
        >
          ←
        </button>

        {/* Bloc texte */}
        <div
          className={`${window.innerWidth <= 768 ? 'text-lg' : 'text-2xl'} italic font-serif`}
          style={{
            flex: "0 0 80%",
            maxWidth: "1000px",
            height: window.innerWidth <= 768 ? "6em" : "7.5em",
            backgroundColor: COLORS.cardBackground,
            color: COLORS.textPrimary,
            padding: window.innerWidth <= 768 ? "1em" : "1.5em",
            borderRadius: "0.5em",
            opacity: 0.8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            boxSizing: "border-box",
            border: `1px solid ${COLORS.primary}`,
            boxShadow: `0 0 15px ${COLORS.primary}33`,
          }}
        >
          <p
            style={{
              lineHeight: "1.4",
              margin: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              fontSize: window.innerWidth <= 768 ? "0.8em" : "1.2em",
              height: window.innerWidth <= 768 ? "4em" : "4.8em",
              minHeight: window.innerWidth <= 768 ? "4em" : "4.8em",
              padding: window.innerWidth <= 768 ? "0 0.3em" : "0 1em",
              wordWrap: "break-word",
              overflowWrap: "break-word",
            }}
            key={currentIndex}
          >
            {safeMissionParts[currentIndex]}
          </p>
        </div>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          className={`absolute ${window.innerWidth <= 768 ? 'w-10 h-10 text-lg' : 'w-12 h-12 text-xl'} rounded-full transition-all duration-300 flex items-center justify-center`}
          style={{
            backgroundColor: COLORS.primary,
            color: COLORS.background,
            right: window.innerWidth <= 768 ? "5px" : "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            border: "none",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = "translateY(-50%) scale(1.1)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.transform = "translateY(-50%) scale(1)")
          }
          onMouseDown={(e) =>
            (e.currentTarget.style.backgroundColor = COLORS.primaryHover)
          }
          onMouseUp={(e) =>
            (e.currentTarget.style.backgroundColor = COLORS.primary)
          }
        >
          →
        </button>
      </div>

      {/* Dots */}
      <div className="flex justify-center space-x-2 mt-6">
        {safeMissionParts.map((_, index) => (
          <div
            key={index}
            className={`${window.innerWidth <= 768 ? 'h-2 w-2' : 'h-3 w-3'} rounded-full`}
            style={{
              backgroundColor:
                index === currentIndex ? COLORS.primary : COLORS.inactiveText,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
}

export default MissionSection;
